module.exports = __webpack_public_path__ + "img/Bligg_Kombination.f59618dc.png";